import intl from "react-intl-universal";


import {ClientUser} from "../../API";
import {ackNotifyUser} from "./ackNotifyUser";
import {ItemModelType} from "@stores/WorkspaceStore";


import {snackBarRef} from "@stores/snackbarRef";
import {CrudServices} from "../../platform/services/types/ServiceDependencies";
import {UserSessionState} from "@stores/UserSessionState";


const isProcessingUserIdSet = new Set<string>();


export const resendNotifications = async (
    services: CrudServices,
    userState: UserSessionState,
    itemMST: ItemModelType | null
) => {
    if (!itemMST) {
        return;
    }
    const unconfirmedUsers = itemMST.unConfirmedUsers;
    for (const wsUser of unconfirmedUsers) {
        await ackNotifyUser(services, userState, wsUser.userId, itemMST);
    }
    snackBarRef.current!.enqueueSnackbar({
        variant: "success",
        message: intl.get('acknowledgment.success_reminder_all').d(`Reminder successfully sent to all users.`)
    });
}

export const resendNotificationOne = async (
    services: CrudServices,
    userState: UserSessionState,
    user: ClientUser,
    itemMST: ItemModelType
) => {
    if (isProcessingUserIdSet.has(user.id)){
        return;
    }
    isProcessingUserIdSet.add(user.id);
    await ackNotifyUser(services, userState, user.id, itemMST);

    const userName = user.name;
    snackBarRef.current!.enqueueSnackbar({
        variant: "success",
        message: intl.get('acknowledgment.success_reminder_one', {userName}).d(`Reminder successfully sent to ${userName}.`)
    });
    isProcessingUserIdSet.delete(user.id);
}